import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ConfirmPasswordValidator } from "../signup/components/confirm-password.validator";
import Swal from "sweetalert2";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { Router } from "@angular/router";
import { GoogleAuthService } from "src/app/core/services/google-auth.service";

@Component({
  selector: "app-enter-new-password",
  templateUrl: "./enter-new-password.component.html",
  styleUrls: ["./enter-new-password.component.scss"],
})
export class EnterNewPasswordComponent implements OnInit {
  hide = true;
  hideConfirmation = true;

  enterNewPassword: FormGroup;

  passwordControl: any;
  confirmPasswordControl: any;
  isDisabled: boolean = false;
  isLoading: boolean = false;

  mode: any;

  constructor(
    private fb: FormBuilder,
    public afAuth: AngularFireAuth,
    private googleService: GoogleAuthService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.enterNewPassword = this.fb.group(
      {
        newPassword: ["", [Validators.required, Validators.minLength(8)]],
        confirmPassword: ["", [Validators.required, Validators.minLength(8)]],
      },
      {
        validator: ConfirmPasswordValidator("newPassword", "confirmPassword"),
      }
    );

    this.passwordControl = this.enterNewPassword.get(
      "newPassword"
    ) as FormControl;
    this.confirmPasswordControl = this.enterNewPassword.get(
      "confirmPassword"
    ) as FormControl;
  }

  changePassword() {

    this.isDisabled = true;
    this.isLoading = true;

    const userPassword = {
      newPassword: this.enterNewPassword.controls.newPassword.value,
      actionCode: localStorage.getItem("actionCode"),
    };

    if (this.enterNewPassword.valid) {
      this.googleService
        .confirmPasswordReset(userPassword.actionCode, userPassword.newPassword)
        .then((result) => {

          this.isDisabled = false;
          this.isLoading = false;
      
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Success!",
            text: "Password updated successfully!",
            showConfirmButton: true,
            showCloseButton: true,
            confirmButtonText: "OK",
          }).then(() => {
            this.router.navigate(["/login"]);
          });
        })
        .catch(() => {

          Swal.fire({
            position: "center",
            icon: "error",
            title: "Reset Password link expired",
            text: "Send another request to reset your password",
            showConfirmButton: false,
            showCloseButton: true,
          });

          this.isDisabled = false;
          this.isLoading = false;

        });
    } else {
      const confirmPasswordControl =
        this.enterNewPassword.get("confirmPassword");
      const newPasswordControl = this.enterNewPassword.get("newPassword");

      if (
        newPasswordControl.value.length < 8 ||
        confirmPasswordControl.value.length < 8
      ) {
        // Password and confirmation do not match

        this.isDisabled = false;
        this.isLoading = false;

        Swal.fire({
          position: "center",
          icon: "error",
          title: "Password must be at least 8 characters long",
          showConfirmButton: false,
          showCloseButton: true,
        });
      } else if (
        // newPasswordControl.value.length > 8 &&
        // confirmPasswordControl.value.length > 8
        confirmPasswordControl.hasError("ConfirmPasswordValidator")
      ) {
        // Handle case when both passwords do not meet the minimum length requirement
        this.isDisabled = false;
        this.isLoading = false;

        Swal.fire({
          position: "center",
          icon: "error",
          title: "Passwords do not match",
          showConfirmButton: false,
          showCloseButton: true,
        });
      } else {
        // Other validation errors
        this.isDisabled = false;
        this.isLoading = false;

        Swal.fire({
          position: "center",
          icon: "error",
          title: "Please fill all required fields",
          showConfirmButton: false,
          showCloseButton: true,
        });
      }
      this.enterNewPassword.markAllAsTouched();
      // Set isLoading back to false to enable the signup button
      this.isDisabled = false;
      this.isLoading = false;
    }

    this.enterNewPassword.markAllAsTouched();
  }
}
